import { config } from '@services/config';
import { QuoteUnderwritingTaskGetOpenTasksResponse } from '@lio/api-types';
import { useQuery } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

export const useUWTasksSummary = (quoteId: string | undefined) => {
  const client = useClient();
  const result = useQuery<QuoteUnderwritingTaskGetOpenTasksResponse, Error>({
    queryKey: ['underwritingTasksSummary'],
    // TODO: Implement proper paging controls
    queryFn: () =>
      client
        .get(`quote/${quoteId}/underwriting-task/summary?pageLimit=100`)
        .json<QuoteUnderwritingTaskGetOpenTasksResponse>(),
    enabled: quoteId !== undefined,
    ...config,
  });
  return {
    ...result,
    underwritingTasksSummary: result.data,
    refetchTasks: result.refetch,
  };
};
